import { apiPost, apiGet, apiDelete, apiPut } from '../utils/api'
import Hotjar from '@hotjar/browser'

export const fetchAdjustmentsAPI = (data) => {
  return apiGet('mgmt/adjustments', data)
}

export const updateAdjustmentAPI = (adjustment) => {
  Hotjar.event('update_adjustment')
  return apiPut(`mgmt/adjustments/${adjustment.id}`, adjustment)
}

export const addNewAdjustmentAPI = (adjustment) => {
  Hotjar.event('add_new_adjustement')
  return apiPost('mgmt/adjustments', adjustment)
}

export const deleteAdjustmentAPI = (adjustmentId) => {
  Hotjar.event('delete_adjustment')
  return apiDelete(`warehouse/mgmt/settings/adjustment/${adjustmentId}`)
}



// WEBPACK FOOTER //
// ./src/api/adjustments.js